import React, { Fragment, useMemo, useState } from 'react';
import { SubLedger } from '../../../../helpers/models/Models';
import { LoadingSpinner } from '../../../../constants/AppLoading';
import AppTable from '../../../../constants/AppTable';
import { StatusBadge } from '../../../../constants/AppBadge';
import AppURL from '../../../../constants/AppURL';
import SubLedgerEditView from './SubLedgerEditView';


interface SubLedgerListViewProps {
    results: {
        results: SubLedger[];
        previous: string | null;
        all: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
    handleFormSuccess: ()=> void;
}

const SubLedgerListView: React.FC<SubLedgerListViewProps> = ({ results, loading, handleFormSuccess, error, setOnURL }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState<SubLedger | null>(null);
    const columns = [
        { header: 'SGLSN', accessor: 'sglsn', sortable: true },
        { header: 'Sub GL Name', accessor: 'sub_ledg_name', sortable: true },
        { header: 'Sub GL Name(Nepali)', accessor: 'sub_ledg_name_nep', sortable: false },
        { header: 'Ledger Type', accessor: 'gl_type_cate', sortable: false },
        { header: 'Details RPT Mode', accessor: 'show_det_modee', sortable: false },
        { header: 'Member List', accessor: 'mem_cate_', sortable: false },
        { header: 'Depresion Rate', accessor: 'dep_rate', sortable: false },
        { header: 'Branch', accessor: 'branch_id', sortable: false },
        { header: 'Diff AC/ON', accessor: 'diff_ac_on', sortable: false },
        { header: 'GLID', accessor: 'glid', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },
    ];
    const modifiedData = useMemo(() => {
        if (!results) return [];
        return results.results.map((item: SubLedger) => ({
            sglsn: item.sglsn,
            sub_ledg_id: item.sub_ledg_id,
            diff_ac_on: item.diff_ac_on,
            sub_ledg_name: item.sub_ledg_name,
            sub_ledg_name_nep: item.sub_ledg_name_nep,
            gl_type_cate: item.gl_type_cat === 1 ? "Assets" : item.gl_type_cat === 2 ? "Liabilities" : item.gl_type_cat === 3 ? "Income" : "Expenses",
            gl_type_cat: item.gl_type_cat,
            show_det_modee: <StatusBadge status={item.show_det_mode} />,
            show_det_mode: item.show_det_mode,
            glid: item.glid,
            active: item.status,
            status: item.status,
            branch_id: item.branch_id,
            dep_rate: item.dep_rate,
            mem_cate_id: item.mem_cate_id,
            mem_cate_: item.mem_cate_id ===1?"Yes":"No",
            actions: (
                <button onClick={() => handleEdit(item)}>Edit</button>
            ),
        }));
    }, [results]);

    const handleEdit = (item: SubLedger) => {
        setCurrentItem(item);
        setDialogOpen(true);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }

    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onEdit={handleEdit}
                onNext={() => results?.next && setOnURL(results.next)}
                onAll={() => results?.next && setOnURL(AppURL.AccountURL+"account/sub/ledger/ledger/list/view/?records=end")}
                onPrev={() => results?.previous && setOnURL(results.previous)}
            />
            <SubLedgerEditView handleFormSuccess={handleFormSuccess} currentItem={currentItem} dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
        </Fragment>
    );
};

export default SubLedgerListView;
